/**
 * momentum-page-store — Page-level momentum data bridge
 *
 * Pages push their entity/entities here when they mount.
 * AppLayout reads from this store to feed the MomentumBar.
 * Parallels chat-context-store for page context.
 *
 * Usage in a page:
 *   const setPageData = useMomentumPageStore(s => s.setPageData);
 *   useEffect(() => {
 *     setPageData({ entity: jobData, pageKey: 'hms.jobs.detail' });
 *     return () => clearPageData();
 *   }, [jobData]);
 */

import { create } from 'zustand';
import type { MomentumConfig } from '@boox/ui-foundation';

export interface MomentumPageData {
  pageKey: string;
  entity?: Record<string, unknown>;
  entities?: Record<string, unknown>[];
  config?: Partial<MomentumConfig>;
}

interface MomentumPageState {
  data: MomentumPageData | null;
  setPageData: (data: MomentumPageData) => void;
  clearPageData: () => void;
}

export const useMomentumPageStore = create<MomentumPageState>((set) => ({
  data: null,
  setPageData: (data) => set({ data }),
  clearPageData: () => set({ data: null }),
}));
